import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { CheckCircle } from 'react-feather';
import { Box } from '@bottomless/common/components';
import { PanelSection } from '../../../../components/PanelSection';

const RequestSuccessMessageComponent = ({ pilotName }) => {
  return (
    <PanelSection title={`Request Your ${pilotName} Product`} className="request-product-success">
      <Box withShadow innerClassName="d-flex flex-column align-items-center">
        <div className="d-flex mt-3 heading">
          <CheckCircle width="20" height="20" className="mr-2" />
          <p>Thank you!</p>
        </div>
        <p className="text-center">
          Our support team will add your {pilotName.toLowerCase()} product and contact
          <br /> you via email within the next business day.
        </p>
        <div className="d-flex flex-column align-items-center my-3">
          <strong>Any Questions?</strong>
          <p>
            Text us on{' '}
            <strong>
              <a href="sms:(206)(260-0782)">(206) 260-0782</a>
            </strong>{' '}
            or email us on{' '}
            <strong>
              <a href="mailto:support@bottomless.com">support@bottomless.com</a>
            </strong>
          </p>
        </div>
      </Box>
    </PanelSection>
  );
};

RequestSuccessMessageComponent.propTypes = {
  pilotName: PropTypes.string.isRequired,
};

export const RequestSuccessMessage = memo(RequestSuccessMessageComponent);
